export default __webpack_public_path__ + "static/media/galeri2.5c45e3ed.jpg";